import { useState } from 'react';
import { useDocumentEvent } from './useDocumentEvent.js';

function useDocumentVisibilityEvent(func, options) {
  const [isVisible, setIsVisible] = useState(typeof document !== "undefined" ? document.visibilityState === "visible" : true);
  useDocumentEvent("visibilitychange", (e) => {
    setIsVisible(document.visibilityState === "visible");
    func?.(e);
  }, options);
  return {
    isDocumentVisible: isVisible
  };
}

export { useDocumentVisibilityEvent };
//# sourceMappingURL=useDocumentVisibilityEvent.js.map
